import React from 'react';

export const LocationIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.99951 6.50024C2.99951 11.0002 7.99951 14.5002 7.99951 14.5002C7.99951 14.5002 12.9995 11.0002 12.9995 6.50024C12.9995 5.17416 12.4727 3.90239 11.535 2.96471C10.5974 2.02703 9.32559 1.50024 7.99951 1.50024C6.67343 1.50024 5.40166 2.02703 4.46398 2.96471C3.5263 3.90239 2.99951 5.17416 2.99951 6.50024V6.50024Z" fill="#9A7A4C"/>
        <path d="M8.00049 8.5C6.89592 8.5 6.00049 7.60457 6.00049 6.5C6.00049 5.39543 6.89592 4.5 8.00049 4.5C9.10506 4.5 10.0005 5.39543 10.0005 6.5C10.0005 7.60457 9.10506 8.5 8.00049 8.5Z" stroke="white" strokeWidth="0.929883" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
